import { useEffect, useRef } from "react";

const WIDGET_ID = "ra-calendar-single-9a01455b8ab311255851e463204652bb";
const SENDER_NAME = "ra-calendar-single-9a01455b8ab311255851e463204652bb";
const SRC =
  "https://roomadmin.pl/widget/calendar-single/index?fh=1592140fbe0869b4a76a108791c0c4baa93a98f6&rid=108825&disableReservationButton=1&style=%7B%22color_accent%22%3A%22%23735239%22%2C%22color_bg%22%3A%22%23FFFFFF%22%2C%22color_header_text%22%3A%22%232a1d12%22%2C%22color_day_available%22%3A%22%232E7D32%22%2C%22color_day_occupied%22%3A%22%23B23A3A%22%2C%22color_day_past%22%3A%22%23D3D3D3%22%7D&n=6&lang=pl";

export default function CalendarWidget() {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    function raMessageReceiver(event) {
      if (!event.data || !event.data.sender || event.data.sender !== SENDER_NAME) {
        return;
      }
      if (event.data.height) {
        iframe.style.height = event.data.height + 10 + "px";
      }
    }

    function setup() {
      try {
        iframe.contentWindow.postMessage(
          {
            location: window.location.toString(),
            setup: {
              autoHeight: true,
              senderName: SENDER_NAME,
            },
          },
          "*"
        );
      } catch (e) {
        /* noop */
      }
    }

    window.addEventListener("message", raMessageReceiver, false);
    const interval = setInterval(setup, 1000);
    iframe.addEventListener("load", setup);

    return () => {
      window.removeEventListener("message", raMessageReceiver, false);
      clearInterval(interval);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      id={WIDGET_ID}
      title="Kalendarz dostępności JATKA NO1"
      data-testid="calendar-widget-iframe"
      src={SRC}
      style={{
        width: "100%",
        height: "600px",
        border: "none",
        padding: 0,
        background: "transparent",
      }}
    />
  );
}
